import PropTypes from 'prop-types';
import { useState } from 'react';
import Checkbox from '../../ui/Checkbox/Checkbox';
import { style as styles } from './Item.style';

const Item = ({ item, onItemChange }) => {
  const [checked, setChecked] = useState(item.checked);
  const handleChange = (payload) => {
    const { isSelected } = payload;
    setChecked(isSelected);
    if (onItemChange) onItemChange(item, isSelected);
  };
  return (
    <div className="item-container">
      <Checkbox
        variant="primary"
        isChecked={checked}
        id={`list-item-${item.tagName}`}
        type="mkp-succes"
        selectedBorderClass=" mkp-border"
        normalBorderClass=" mkp-normal-border"
        onChange={handleChange}
      >
        {item.tagName}
      </Checkbox>
      <style jsx>{styles}</style>
    </div>
  );
};

Item.propTypes = {
  item: PropTypes.object.isRequired,
  onItemChange: PropTypes.func,
};

Item.defaultProps = {
  onItemChange: undefined,
};

export { Item };
